
( function( $ ) {
    /*
     * Update the login box in the top right corner using AJAX
     */
    function updateHeaderLogin() {
        if ($('.header-subscription').length < 1) {
            return;
        }

        $.ajax({
            url : themevars.ajaxurl,
            data : {
                action : 'update_header',
            },
            type : 'POST',
            dataType : 'json'
        }).done( function (result) {
            if (!result.success || !result.data.headerlogin) {
                return;
            }

            $('.header-subscription').replaceWith(result.data.headerlogin);
        });
    }

    updateHeaderLogin();

} )( jQuery );

//open search in header
document.addEventListener("DOMContentLoaded", function () {
    const searchToggle = document.getElementById("search-toggle");
    const searchForm = document.getElementById("header-search-form");

    searchToggle.addEventListener("click", function () {
        const isExpanded = searchToggle.getAttribute("aria-expanded") === "true";

        searchToggle.setAttribute("aria-expanded", !isExpanded);
        searchForm.classList.toggle("visible", !isExpanded);
    });
});
